import { render, staticRenderFns } from "./FramePopup.vue?vue&type=template&id=4564288a&"
import script from "./FramePopup.vue?vue&type=script&lang=ts&"
export * from "./FramePopup.vue?vue&type=script&lang=ts&"
import style0 from "./FramePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports